import React, { useContext, useEffect } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import {
	ApplicationDispatchContext,
	LOAN_APPLICATION_ACTIONS,
} from 'contexts/ApplicationContext'
import { IApplicationContext } from 'interfaces/i-application-context-props'

const ThankYouUK = () => {
	const { t } = useTranslation()
	const { loanApplication, dispatchLoanApplication }: IApplicationContext =
		useContext(ApplicationDispatchContext)

	const isOnThankYouPage = () => {
		dispatchLoanApplication({
			type: LOAN_APPLICATION_ACTIONS.SET_IS_ON_THANKYOU_PAGE,
			payload: {
				...loanApplication,
				isOnThankYouPage: true,
			},
		})
	}

	useEffect(
		() => {
			isOnThankYouPage()
		},
		[], //eslint-disable-line
	)

	const steps = [
		{
			title: t('ThankYouStepCheckEmailTitle'),
			description: t('ThankYouStepCheckEmailDescription'),
		},
		{
			title: t('ThankYouStepVisitMyPagesTitle'),
			description: (
				<Trans
					t={t}
					i18nKey="ThankYouStepVisitMyPagesDescription"
					components={[
						<a
							href="https://avarda.uk/mypages"
							target="_blank"
							rel="noreferrer">
							My Pages
						</a>,
					]}
				/>
			),
		},
		{
			title: t('ThankYouStepDownloadAppTitle'),
			description: t('ThankYouStepDownloadAppDescription'),
		},
	]

	return (
		<div className="thank-you-uk">
			<p className="thank-you-uk-description">
				{t('ThankYouDescription')}
			</p>
			<h2 className="thank-you-uk-subheading">
				{t('ThankYouWhatsNextHeader')}
			</h2>
			<ol className="thank-you-uk-steps">
				{steps.map((step, index) => (
					<li key={step.title} className="thank-you-uk-step">
						<span className="thank-you-uk-step-number">
							{index + 1}
						</span>
						<div className="thank-you-uk-step-content">
							<span className="thank-you-uk-step-title">
								{step.title}
							</span>
							<span className="thank-you-uk-step-description">
								{step.description}
							</span>
						</div>
					</li>
				))}
			</ol>
		</div>
	)
}

export default ThankYouUK
